"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEB_BUS_SOURCE = exports.WebBusEventSchemas = exports.WebTrackingStatusSchema = exports.WebSettingsPatchSchema = exports.WebBlockCreateSchema = exports.WebBlockSchema = exports.WebIncidentSchema = exports.WEB_INCIDENT_TYPES = exports.WebSiteSchema = exports.WebFilterSchema = exports.WebRangeSchema = exports.WebCollectEventSchema = exports.WEB_COMPANY_STEPS = exports.WEB_STORE_STEPS = exports.WEB_COUNTERS = exports.WebDimSchema = exports.WEB_DIMS = exports.webTenantIdFromSiteId = exports.webSiteIdForTenant = exports.WEB_SITE_COMPANY = exports.WEB_SITE_ALL = void 0;
const zod_1 = require("zod");
exports.WEB_SITE_ALL = '_all';
exports.WEB_SITE_COMPANY = 'rubytill';
const webSiteIdForTenant = (tenantId) => `t_${tenantId}`;
exports.webSiteIdForTenant = webSiteIdForTenant;
const webTenantIdFromSiteId = (siteId) => siteId.startsWith('t_') ? siteId.slice(2) : null;
exports.webTenantIdFromSiteId = webTenantIdFromSiteId;
exports.WEB_DIMS = ['page', 'entry', 'exit', 'source', 'channel', 'referrer', 'campaign', 'country', 'city',
    'device', 'browser', 'os', 'search', 'notfound', 'product', 'visitorType', 'site'];
exports.WebDimSchema = zod_1.z.enum(exports.WEB_DIMS);
exports.WEB_COUNTERS = ['pv', 'visits', 'entries', 'exits', 'bounces', 'durSec', 'hits', 'orders',
    'revenueCents', 'signups'];
exports.WEB_STORE_STEPS = ['product_view', 'add_to_cart', 'checkout_start', 'order'];
exports.WEB_COMPANY_STEPS = ['pricing_view', 'signup_start', 'account_created', 'subscription'];
exports.WebCollectEventSchema = zod_1.z.object({
    t: zod_1.z.enum(['pageview', 'leave', 'event']),
    n: zod_1.z.string().max(40).optional(), // event name when t==='event'
    sid: zod_1.z.string().regex(/^[a-z0-9]{8,32}$/),
    p: zod_1.z.string().max(300), // path (+ hash route for platform-app)
    r: zod_1.z.string().max(500).optional(), // document.referrer
    ti: zod_1.z.string().max(200).optional(),
    u: zod_1.z.record(zod_1.z.string().max(120)).optional(), // utm_source/medium/campaign/term/content
    sw: zod_1.z.number().int().min(0).max(10000).optional(),
    lg: zod_1.z.string().max(20).optional(),
    ret: zod_1.z.boolean().optional(),
    wd: zod_1.z.boolean().optional(), // navigator.webdriver
    es: zod_1.z.number().min(0).max(86400).optional(), // engaged seconds (leave)
    pr: zod_1.z.record(zod_1.z.union([zod_1.z.string().max(200), zod_1.z.number()])).optional(),
});
exports.WebRangeSchema = zod_1.z.object({
    range: zod_1.z.enum(['today', '7d', '30d', '90d', '12m', 'custom']).default('30d'),
    from: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
    to: zod_1.z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
    compare: zod_1.z.coerce.boolean().default(true),
});
exports.WebFilterSchema = zod_1.z.object({ dim: exports.WebDimSchema, value: zod_1.z.string().max(300) });
exports.WebSiteSchema = zod_1.z.object({
    siteId: zod_1.z.string(), kind: zod_1.z.enum(['store', 'company']), tenantId: zod_1.z.string().optional(),
    name: zod_1.z.string(), timezone: zod_1.z.string(), hostnames: zod_1.z.array(zod_1.z.string()),
    settings: zod_1.z.object({
        excludeStaff: zod_1.z.boolean().default(true), botFilter: zod_1.z.boolean().default(true),
        weeklyReport: zod_1.z.boolean().default(true), securityAlerts: zod_1.z.boolean().default(true),
        alertRecipients: zod_1.z.array(zod_1.z.string().email()).max(10).default([]),
        excludedIps: zod_1.z.array(zod_1.z.string()).max(50).default([]),
    }),
    protection: zod_1.z.object({ managedRules: zod_1.z.boolean().default(true), rateLimits: zod_1.z.boolean().default(true) }),
    lastEventAt: zod_1.z.record(zod_1.z.string()).default({}),
});
exports.WEB_INCIDENT_TYPES = ['card_testing', 'credential_stuffing', 'admin_login', 'path_probing', 'scraper', 'traffic_spike'];
exports.WebIncidentSchema = zod_1.z.object({
    siteId: zod_1.z.string(), incidentId: zod_1.z.string(), type: zod_1.z.enum(exports.WEB_INCIDENT_TYPES),
    severity: zod_1.z.enum(['High', 'Medium', 'Low']), source: zod_1.z.string(), country: zod_1.z.string().optional(),
    network: zod_1.z.string().optional(), hits: zod_1.z.number(), firstAt: zod_1.z.string(), lastAt: zod_1.z.string(),
    detail: zod_1.z.string(), status: zod_1.z.enum(['watching', 'blocked', 'resolved']),
});
exports.WebBlockSchema = zod_1.z.object({
    blockId: zod_1.z.string(), scope: zod_1.z.string(), // 'all' | siteId
    kind: zod_1.z.enum(['ip', 'net24', 'country', 'bot']), target: zod_1.z.string(),
    until: zod_1.z.string().nullable(), // ISO or null = permanent
    reason: zod_1.z.string().max(200), createdBy: zod_1.z.string(), createdByKind: zod_1.z.enum(['admin', 'tenant', 'platform']),
    createdAt: zod_1.z.string(), sync: zod_1.z.enum(['pending_sync', 'applied', 'failed']),
});
exports.WebBlockCreateSchema = zod_1.z.object({
    kind: exports.WebBlockSchema.shape.kind, target: zod_1.z.string().min(1).max(200),
    duration: zod_1.z.enum(['1h', '24h', '7d', '30d', 'permanent']), scope: zod_1.z.enum(['site', 'all']).default('site'),
    reason: zod_1.z.string().max(200).default(''),
});
/**
 * PUT /admin|my/sites/{siteId}/settings (Task 12). Flat `settings` keys plus an optional
 * `protection` object — a tenant sending `protection` at all gets 403 (the service checks
 * before this schema). The service further canonicalises recipients / IPs.
 */
exports.WebSettingsPatchSchema = zod_1.z.object({
    excludeStaff: zod_1.z.boolean().optional(), botFilter: zod_1.z.boolean().optional(),
    weeklyReport: zod_1.z.boolean().optional(), securityAlerts: zod_1.z.boolean().optional(),
    alertRecipients: zod_1.z.array(zod_1.z.string().max(254).email()).max(10).optional(),
    excludedIps: zod_1.z.array(zod_1.z.string().max(64)).max(50).optional(),
    protection: zod_1.z.object({ managedRules: zod_1.z.boolean().optional(), rateLimits: zod_1.z.boolean().optional() }).strict().optional(),
}).strict();
exports.WebTrackingStatusSchema = zod_1.z.object({
    hostname: zod_1.z.string(), status: zod_1.z.enum(['receiving', 'no_data']), lastEventAt: zod_1.z.string().optional(),
});
exports.WebBusEventSchemas = {
    'storefront.order.placed': zod_1.z.object({ tenantId: zod_1.z.string().min(1), orderId: zod_1.z.string(), rtSid: zod_1.z.string().optional(), totalCents: zod_1.z.number().int(), currency: zod_1.z.string() }),
    'storefront.payment.declined': zod_1.z.object({ tenantId: zod_1.z.string().min(1), ip: zod_1.z.string(), cartId: zod_1.z.string(), code: zod_1.z.string().optional() }),
    'storefront.login.failed': zod_1.z.object({ tenantId: zod_1.z.string().min(1), ip: zod_1.z.string(), account: zod_1.z.string(), accountHash: zod_1.z.string().regex(/^[0-9a-f]{16}$/).optional() }),
    'storefront.login.succeeded': zod_1.z.object({ tenantId: zod_1.z.string().min(1), ip: zod_1.z.string() }),
    'rubytill.signup.completed': zod_1.z.object({ tenantId: zod_1.z.string().min(1), rtSid: zod_1.z.string().optional(), plan: zod_1.z.string().optional(), amountCents: zod_1.z.number().int().optional() }),
};
exports.WEB_BUS_SOURCE = 'rubytill.web';
//# sourceMappingURL=webAnalytics.js.map